import { render, staticRenderFns } from "./Doughnut.vue?vue&type=template&id=a1c286c2&"
import script from "./Doughnut.vue?vue&type=script&lang=ts&"
export * from "./Doughnut.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports